import i18next from 'i18next';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { setCountryCode, setLanguage, setCurrencyHeader, setMeasurementHeader } from 'store/common/utils';
import { abortController } from 'store/utils';
import countriesStore from 'store/countries';
import { CURRENCIES, COUNTRIES } from 'const';
import { getExchangeApi } from './api';
const lang = window.localStorage.getItem('lang') || 'en';
const countryFromLocalStorage = window.localStorage.getItem('countryCode') || 'AE';
const countryCode = COUNTRIES.includes(countryFromLocalStorage) ? countryFromLocalStorage : 'AE';
const countryName = window.localStorage.getItem('countryName') || '';
const currencyCode = window.localStorage.getItem('currencyCode') || 'AED';
const priceMeasurement = window.localStorage.getItem('priceMeasurement') || 'AED';
const localStorageSquareMeasurement = window.localStorage.getItem('squareMeasurement') || 'ft2';
const squareMeasurement = ['ft2', 'm2'].includes(localStorageSquareMeasurement) ? localStorageSquareMeasurement : 'ft2';
setLanguage(lang);
document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
setCountryCode(countryCode);
setCurrencyHeader(priceMeasurement);
setMeasurementHeader(squareMeasurement);
const initialState = {
    currencyCode,
    lang,
    countryCode,
    countryName,
    priceMeasurement,
    squareMeasurement,
    exchange: {
        AED: 1,
    },
};
const actions = {
    setMeasurements: ({ type, val: measurement }, { setState, getState }) => {
        const current = getState()[type];
        if (current === measurement)
            return;
        setState({ [type]: measurement });
        window.localStorage.setItem(type, measurement);
        if (type === 'lang') {
            document.documentElement.dir = measurement === 'ar' ? 'rtl' : 'ltr';
            i18next.changeLanguage(measurement);
            setLanguage(measurement);
            const { getAvailableContinents } = countriesStore.getState();
            getAvailableContinents(undefined);
        }
        if (type === 'countryCode') {
            setCountryCode(measurement);
        }
        if (type === 'priceMeasurement') {
            setCurrencyHeader(getState().priceMeasurement);
        }
        if (type === 'squareMeasurement') {
            setMeasurementHeader(getState().squareMeasurement);
        }
    },
    getExchange: async (currency, { setState }) => {
        const { data } = await getExchangeApi(currency);
        const exchange = CURRENCIES.reduce((acc, item) => ({
            ...acc,
            [item]: data.find(({ to }) => to === item)?.rate,
        }), {});
        setState({ exchange });
    },
};
const store = { ...initialState, ...actions };
export default create()(devtools(immer((set, get) => abortController(store, set, get, 'Measurements')), {
    name: 'Measurements',
}));
